<!--详情页面-->
<template>
  <el-dialog
    :title="pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle"
    :visible.sync="dialogMachiningVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle}}</p>
      <div v-if="controlData.isjiaji==1" style="color:red;margin-left: 20px;font-weight:bold;float:left ">
        <span>加急！！</span>（{{controlData.wantarrivaltime}}）
      </div>
      <div style="width: 640px;margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             :style="{background:backimg}" class="print-table">
        <tr class="noborder" style="height: 26px">
          <td align="right" width="60">订单号：</td>
          <td width="140">{{controlData.erpserial}}</td>
          <td align="right" width="40">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right" width="60">类&nbsp;&nbsp;型：</td>
          <td width="200"><span style="color: red"><b>{{seedname}}&nbsp;&nbsp;x{{sumnumber}}</b> </span><span
            style="color: red" v-if="(printDisplay||!isprint)"><b>、 {{summoney}}元</b></span></td>
        </tr>
        <tr class="noborder" style="height: 26px" v-if="controlData.pcustomer==controlData.servedname">
          <td align="right">客 户：</td>
          <td>{{controlData.customername}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.deliveryaddress}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">加工点：</td>
          <td>{{controlData.pcustomer}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.caddress}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee+" "+controlData.deliverymode}}</td>
          <td align="right"><span v-if="controlData.status>300">单&nbsp;&nbsp;号：</span></td>
          <td>
            <span v-if="controlData.status>300">{{controlData.logisticsnum||''}} {{controlData.logisticsco||''}}</span>
          </td>
          <td align="right" v-if="controlData.handleoverdate">发货时：</td>
          <td>{{controlData.handleoverdate}}</td>
        </tr>
        <tr class="noborder no-print" v-if="isfahuo&&!isprint" style="height:26px">
          <td align="right">物&nbsp;&nbsp;流：</td>
          <td>
            <el-select v-model="controlData.logisticsco" placeholder="请选择" style="width: 125px;" size="mini">
              <el-option
                v-for="item in parameterData"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td align="right">快递：</td>
          <td>
            <el-input v-model="logisticsnumPre" auto-complete="off" required="true" size="mini" style="width: 135px;" placeholder="请填写快递单号"></el-input>
            <el-input v-model="logisticsnumEnd" v-show="controlData.logisticsco&&controlData.logisticsco.indexOf('顺丰')>-1" auto-complete="off" required="true" size="mini" style="width: 135px;" placeholder="寄件人手机号后4位"></el-input>
         </td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr class="noborder" v-if="isreturnorder"
            style="font-weight:bold;cursor:pointer"
            @click="lookDetails(controlData.sycstagreementDO)">
          <td align="right">原订单：</td>
          <td>{{controlData.sycstagreementDO.erpserial?controlData.sycstagreementDO.erpserial:""}}</td>
          <td align="right">状 &nbsp;态：</td>
          <td>
            {{controlData.sycstagreementDO&&parseFloat(controlData.sycstagreementDO.status)>300?'已加工':'待加工'}}
          </td>
          <td align="right"></td>
          <td></td>
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td
                  v-if="item !='seedcode'&&item != 'packagesize'&&item !='unitguid'&&item !='单价'&&item !='总价'&&item !='订单状态'"
                  style="text-align: center;"
                  v-for="item in column">
                  {{item}}
                </td>
                <td v-if="(!isprint)&&tableData.length>0">订单状态</td>
                <td v-if="(!isprint)&&tableData.length>0">单价</td>
                <td v-if="(!isprint)&&tableData.length>0">总价</td>
              </tr>
              <tr v-for="item in tableData">
                <td
                  :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'90px':''}"
                  v-for="(ob,index) in item"
                  v-if="index!=0&&index!=item.length-1&&index!=item.length-2&&index!=item.length-3&&typeof(ob['unitguid'])=='undefined'&&typeof(ob['packagesize'])=='undefined'">
                  <span v-for="value in ob" @click="getOpenOrder(ob)">{{value}}</span>
                </td>
                <td v-if="(!isprint)&&tableData.length>0">{{item[item.length-3]['订单状态']}}</td>
                <td v-if="(!isprint)&&tableData.length>0">
                  {{parseFloat(item[item.length-2]['单价']).toFixed(2)}}
                </td>
                <td v-if="(!isprint)&&tableData.length>0">
                  {{parseFloat(item[item.length-1]['总价']).toFixed(2)}}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="5" style="border:none">
            <table>
              <tr v-for="item in formpropertyData">
                <td align="left" style="padding-left: 0px;padding-right: 0px;" width="170"
                    v-for="(item2,index) in item">{{index+"："+item2}}
                </td>
              </tr>
            </table>
          </td>
          <td class="no-print">
            <el-checkbox-group v-model="checkedGlasses" @change="handleCheckedGlassesChange">
              <el-checkbox v-for="glasses in glassess" :label="glasses" :key="glasses">{{glasses}}</el-checkbox>
            </el-checkbox-group>
          </td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td colspan="4">开单人员：{{controlData.uname||''}}</td>
          <td colspan="2">加工人员：{{machiner||''}}</td>
        </tr>
        <tr class="noborder" style="height: 30px">
          <td colspan="6"></td>
        </tr>
        <tr class="noborder" style="height: 26px">
          <td align="right">服务商：</td>
          <td>{{controlData.servedname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
        <tr v-if="!isprint">
          <td colspan="6">
            <BaoSunList ref="BaoSunList"></BaoSunList>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogMachiningVisible = false;">取 消</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn" v-if="isfahuo&&controlData.status==350" :loading="loading">确认发货</el-button>
      <el-button type="primary" @click="machiningOver" v-if="getBtnVisible()" class="qrbtn"  :loading="loading">加工完成</el-button>
      <el-button type="warning" @click="baosun" v-if="getZlJCVisible()">质检不合格</el-button>
      <el-button type="primary" @click="print1" v-if="roletype!='order'&&status!=200">打印</el-button>
      <span @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
      <span @click="handleloglook" style="position: absolute;bottom: 25px;right: 10px">(处理日志)</span>
    </div>
    <printlogList ref="printlogList"></printlogList>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <CstagreementMachiningBaosun ref="machiningbaosun" @bindGrid="rebindBaoSun"></CstagreementMachiningBaosun>
    <Printtitle ref="Printtitle" @printtitlename="printtitlename" @cancelprint="cancelprint"></Printtitle>
  </el-dialog>
</template>


<script>

  import {machiningOrder, finishing, checkprinting, glassesArrival,multipleShipments} from '@/api/set/csagreement';
  import {getRemark} from '@/plugin/ordercommon'
  import printlogList from './printlogList'
  import CstagreementMachiningBaosun from './CstagreementMachiningBaosun'
  import {saveData, getListData} from '@/api/set/handlelog';
  import HandlelogList from './HandlelogList'
  import {save} from '@/api/order/printlog';
  import BaoSunList from './BaoSunList'
  import Printtitle from './Printtitle'
  import {getParameterDetail} from '@/api/set/parameter';
  export default {
    name: 'CstagreementMachiningEdit',
    data() {
      return {
        loading:false,
        backimg: '',
        imgpath: '',
        isfahuo:false,
        uname: '',//最新一条打印人员
        adddate: '',//最新一条打印时间
        canOperate: 0,//加工单只有点击确认的时候才显示加工完成按钮
        dialogMachiningVisible: false,
        formLabelWidth: '120px',
        parameterData:[],
        logisticsnumPre: '',
        logisticsnumEnd: '',
        groupguid: '',
        seedcode: "",
        tableData: [],
        unitguid: "",
        erpserial: '',
        column: [],
        controlData: {logisticsco:""},
        showtitle1: "none",
        deliveryaddress: '',
        jxcstoreData: [],
        seedname: '',
        formproperty: [],//  下部区域的参数
        count: 0,
        formpropertyData: [],
        isreturnorder: false,
        sycstagreementDO: [],
        sumnumber: '',
        summoney: '',
        drawer: '',//开单人员
        machiner: '',//出库人员
        handlelogData: [],//处理日期
        // categoryname:'' //镜框类型
        printDisplay: false,//是否显示单价和总价
        isprint: false,//控制价格显示
        glassess: ['镜架已到', '镜片已到'],
        checkedGlasses: [],
        roletype: '',//岗位类型
        status: '',//订单状态
        zjyright: false,
        showlookprice: false,//根据
        pagetitle: ''
      }
    },
    methods: {
      //报损
      baosun() {
        this.$refs.machiningbaosun.show(this.controlData, this.column, this.tableData)
      },
      bindBaoSun() {//绑定报损单
        var erpserials = '';
        for (let i = 0; i < this.tableData.length; i++) {
          if (erpserials.indexOf(this.tableData[i]["销售单号"]) < 0) {
            erpserials += (erpserials == '' ? '' : ';') + this.tableData[i]["销售单号"];
          }
        }
        this.$refs.BaoSunList.bind(erpserials);
      },
      rebindBaoSun() {//重新绑定报损单
        this.$refs.BaoSunList.rebind();
      },
      //镜片、镜架是否已到
      handleCheckedGlassesChange(val) {
        var remark = ''
        if (val.length == 2) {
          remark = val[0] + "," + val[1]
        } else if (val.length == 1) {
          remark = val[0]
        }
        glassesArrival({
          unitguid: this.controlData.unitguid,
          erpserial: this.controlData.erpserial,
          remark: remark
        }).then(response => {
          //刷新列表
          this.$emit("bindGrid")
        })
      },
      //开单人员
      billingStaff(casestepname) {
        this.drawer = '';
        this.machiner = '';
        getListData({
          erpserial: this.controlData.erpserial,
          casestepname: casestepname,
        }).then(response => {
          this.handlelogData = response.data.obj
          if (this.handlelogData.length > 0) {
            if (casestepname == '通知加工') {
              this.drawer = this.handlelogData[0].uname
            } else if ((casestepname == '加工完成')) {
              this.machiner = this.handlelogData[0].uname
            }
          }
        })
      },
      //查看处理日志
      handleloglook() {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(this.form.erpserial);
      },
      //处理日志
      handlelog(hn) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.casestepname = hn
        handlelog.remark = hn
        saveData(handlelog).then(response => {
        })
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.erpserial);
      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      getOpenOrder(ob) {
        if (ob["销售单号"]) {
          this.$parent.lookDetails({erpserial: ob["销售单号"]})
        }
      },
      getBtnVisible() {
        return this.controlData.status == 300 && this.canOperate == 1
      },
      getZlJCVisible() {
        return (this.controlData.status > 200) && this.zjyright && !this.isfahuo
      },
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i])
              obj[i] += "加工单"
          }
          result = obj.join(';')
        } else {
          result += "加工单"
        }
        return result
      },
      // showDetail(item) {
      //   this.$refs.seeddetail.show()
      //   this.$refs.seeddetail.initData(this.unitguid, item[0].seedcode)
      // },
      print1() {
        this.showtitle1 = ""
        this.isprint = true
        if(this.controlData.logisticsco) {
          if (this.controlData.logisticsco.indexOf('顺丰') > -1) {
            this.controlData.logisticsnum = this.logisticsnumPre + ':' + this.logisticsnumEnd;
          } else {
            this.controlData.logisticsnum = this.logisticsnumPre;
          }
        }
        checkprinting({erpserial: this.erpserial}).then(response => {
          var printD = response.data.obj.rows;
          if (printD.length > 0) {//表示打印过，需要做出提醒
            this.$confirm('该订单“' + printD[0].uname + '”已于' + printD[0].adddate + '打印过，是否继续?', '提示', {
              confirmButtonText: '取消',
              cancelButtonText: '继续打印',
              type: 'error'
            }).then(() => {
             this.cancelprint();
            }).catch(() => {
              if (this.pagetitle.indexOf(";") != -1)
                this.$refs.Printtitle.show(this.pagetitle, false)
              else
                this.startprint(false);
            });
          } else {
            if (this.pagetitle.indexOf(";") != -1)
              this.$refs.Printtitle.show(this.pagetitle, true)
            else
              this.startprint(true);
          }
        });
      },
      printtitlename(pagetitle, needreflash) {
        this.pagetitle = pagetitle
        this.startprint(needreflash)
      },
      cancelprint(){
        this.showtitle1 = "none"
        this.isprint = false
      },
      startprint(needreflash) {
        this.showtitle1 = ""
        this.isprint = true
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
          this.isprint = false
          save({erpserial: this.erpserial, invoicesource: 5}).then(response => {
            if (response.data.code == 0) {
              if (needreflash) {
                this.dialogMachiningVisible = false
                this.$emit("bindGrid");//未打印过，刷新父页面
              }
              this.$message({
                message: '生成打印日志',
                type: 'success'
              })
            }
          })
        })
      },
      show(roletype) {

        this.roletype = roletype
        this.dialogMachiningVisible = true;

      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },

      lookDetails(row) {
        this.$parent.lookMachiningCopy(row)
      },

      initData(row, canOperate,isfahuo) {
        this.initForm()
        this.isfahuo=isfahuo=='填写发货单'
        this.canOperate = canOperate
        this.formpropertyData = []
        this.erpserial = row.erpserial
        this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + row.erpserial
        this.groupguid = row.groupguid
        this.unitguid = row.unitguid
        this.erpserial = row.erpserial
        this.status = row.status
        if (row.logisticsnum) {
          this.controlData.logisticsnum = row.logisticsnum
          if (row.logisticsnum.indexOf(':') > -1) {
            this.logisticsnumPre = this.controlData.logisticsnum.split(':')[0];
            this.logisticsnumEnd = this.controlData.logisticsnum.split(':')[1];
          } else {
            this.logisticsnumPre = this.controlData.logisticsnum;
          }
        }
        this.bindGrid()
      },
      bindGrid() {
        machiningOrder({
          unitguid: this.unitguid,
          groupguid: this.groupguid,
          erpserial: this.erpserial
        }).then(response => {
          //打印日志
          if (response.data.obj.printlogDOList && response.data.obj.printlogDOList.length > 0) {
            this.printData = response.data.obj.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }
          this.controlData = response.data.obj.detail;

          if (this.controlData.logisticsnum) {
            if (this.controlData.logisticsnum.indexOf(':') > -1) {
              this.logisticsnumPre = this.controlData.logisticsnum.split(':')[0];
              this.logisticsnumEnd = this.controlData.logisticsnum.split(':')[1];
            } else {
              this.logisticsnumPre = this.controlData.logisticsnum;
            }
          }

          if (this.controlData.remark != '' && this.controlData.remark != undefined) {
            var remark = JSON.parse(this.controlData.remark.replace(new RegExp("\n", "gm"), ""));
            remark.forEach(item => {
              if (item.type == '眼镜已到') {
                this.checkedGlasses = item.msg == '' || item.msg == undefined ? [] : item.msg.split(',')
              }
            })
          }
          this.tableData = response.data.obj.goodsDetail;
          this.sumnumber = response.data.obj.sumnumber
          this.summoney = response.data.obj.summoney
          this.bindBaoSun();

          if (this.controlData.isreturnorder && this.controlData.isreturnorder == 1) {
            this.isreturnorder = true
          } else {
            this.isreturnorder = false
          }
          if (this.controlData.isreturnorder == -1) {
            this.backimg = 'url("/static/img/tuihuotipbig.png") center center no-repeat';
          }
          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          this.seedname = response.data.obj.seedname;
          this.formproperty = JSON.parse(response.data.obj.formproperty);
          this.printDisplay =true;// (this.controlData.isshowprice.indexOf('4') != -1);
          // this.categoryname=response.data.obj.categoryname;
          if (this.tableData.length > 0) {
            //取出表头
            let temparr = []
            let biaoji = 0
            for (let i in this.tableData) {
              if (this.tableData[i]["订单状态"] != "已发货") {
                this.count++
              }
              for (let j in this.tableData[i]) {
                if (j == "R/L") {
                  biaoji = 1
                }
                if (j != "seedcode" && j != "R/L" && j != "数量" && j != "订单状态" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "单价" && j != "总价") {
                  temparr.push(j)
                }
              }
            }
            //对表头排序
            this.column.push("seedcode")
            if (biaoji == 1) {
              this.column.push("R/L")
            }
            this.column.push("产品名称")
            this.column.push("球镜")
            this.column.push("柱镜")
            this.column.push("轴位")
            this.column = this.column.concat(temparr)
            this.column.push("数量")
            this.column.push("订单状态")
            this.column.push("单价")
            this.column.push("总价")
            //this.column.push("说明")

            this.tableData = this.tableData.map(o1 => this.column.map(o2 => {
              let ob = {}
              ob[o2] = o1[o2]
              return ob
            }))
          }
          //解析参数
          if (this.formproperty.length > 0) {
            let biaoji = 0;
            for (let j in this.formproperty[0]) {
              if (this.formproperty[0][j] != 'M') {
                if (biaoji % 4 == 0) {
                  let temp = {}
                  temp[j] = this.formproperty[0][j]
                  this.formpropertyData.push(temp)
                } else {
                  this.formpropertyData[this.formpropertyData.length - 1][j] = this.formproperty[0][j]
                }
                biaoji++
              }
            }
          }
          this.billingStaff('通知加工')
          this.billingStaff('加工完成')
        });
      },
      machiningOver() {
        this.loading=true;
        finishing({unitguid: this.unitguid}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '加工完成',
              type: 'success'
            })
            this.handlelog("加工完成");
          } else {
            this.loading=false
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }

          this.dialogMachiningVisible = false
          //刷新列表
          this.$emit("bindGrid")
        })
      },
      showError(errorinfo) {
        this.$message({
          message: errorinfo,
          type: 'error'
        })
        this.loading=false
      },
      delivergoods() {
        if(this.controlData.logisticsco==null)
          this.controlData.logisticsco='';

        if ((this.controlData.logisticsco.indexOf('快递') > -1 || this.controlData.logisticsco.indexOf('顺丰') > -1) && !this.logisticsnumPre) {
          this.showError('请填写快递单号！')
          return;
        }
        if (this.controlData.logisticsco.indexOf('顺丰') > -1) {
          if (!this.logisticsnumEnd) {
            this.showError('请输入寄件人手机号后4位')
            return
          }
          this.controlData.logisticsnum = this.logisticsnumPre + ':' + this.logisticsnumEnd;
          localStorage.setItem("hpapi_sendexpressmobile", this.logisticsnumEnd);
        } else {
          this.controlData.logisticsnum = this.logisticsnumPre;
        }
        this.loading=true
        multipleShipments({
          erpserial: this.controlData.erpserial,
          deliverymode: this.controlData.deliverymode,
          logisticsco: this.controlData.logisticsco,
          logisticsnum: this.controlData.logisticsnum,
          customername: this.controlData.customername,
          jxcformdetaillist: this.controlData.jxcformdetaillist,
          customerserial: this.controlData.customerserial,
          independentserial: '',
          cangkucode: this.controlData.cangkucode,
          cangkuname: this.controlData.cangkuname,
          origionstatus: '',
          jxcformDetailDo: '',
          isdistribute: '',
          formtype: 72,
          orderopinion: '',
          eliverydStatus: '',
          storegoodsbarcode: '',//库存商品唯一条码
          logisticstracknum: '',//跟踪单号
          invoicesource: 2
        }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: response.data.msg,
                type: 'success'
              })
              this.dialogMachiningVisible = false
              this.handlelog("仓库发货");
              //刷新列表
              this.$emit("cutItemAfterHandle", this.controlData.erpserial)
            } else {
              this.showError(response.data.msg)
            }
          }
        );
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.logisticsnumPre = '';
        this.logisticsnumEnd = localStorage.getItem("hpapi_sendexpressmobile");
        if (this.logisticsnumEnd == null)
          this.logisticsnumEnd = '';
        this.loading=false;
        this.backimg = '';
        this.groupguid = ""
        this.column = []
        this.tableData = []
        if (this.$refs.BaoSunList)
          this.$refs.BaoSunList.clear();
        this.unitguid = ""
        this.uname = ''
        this.adddate = ''
        this.printDisplay = false
        this.checkedGlasses = []
      }
    },
    mounted() {
      this.zjyright = this.$checkRight("质检员")
      getParameterDetail({paraname: "快递公司"}).then(response => {
        var parac = response.data.obj?response.data.obj.paracontent:null;
        if (!parac) parac = '[{"name":"自取","value":"10"}]';
        var paracontent = JSON.parse(parac);

        for (let i = 0; i < paracontent.length; i++) {
          var obj = {
            name: '', value: ''
          }
          obj.name = paracontent[i].name
          obj.value = paracontent[i].name
          this.parameterData.push(obj)
        }
      })
    },
    components: {
      printlogList,
      HandlelogList,
      CstagreementMachiningBaosun,
      BaoSunList,
      Printtitle
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementMachiningEdit.vue